var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-title"},[_c('h1',[_c('router-link',{attrs:{"to":"/","rel":"home"}},[_c('span',{staticClass:"logo logo-1x"},[_c('img',{staticClass:"default",style:(_vm.isvisible),attrs:{"src":"/assets/logo/230-89.png","alt":""}})])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }